import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import CustomsQuotasTermsPopup from 'components/CustomsQuotasTermsPopup';
import Link, { LINK_BEHAVIORS } from 'components/Link';
import './CustomsQuotasViewTermsAndConditions.scss';

const CustomsQuotasViewTermsAndConditions = ({
  text,
  linkText,
  termsPopup,
}) => {
  const termsPopupRef = useRef(null);

  const openPopup = () => {
    if (termsPopupRef && termsPopupRef.current) {
      termsPopupRef && termsPopupRef.current.openPopup();
    }
  };

  return (
    <React.Fragment>
      <p className="customs-quotas-view-terms-and-conditions">
        {text}{' '}
        <Link
          onClick={openPopup}
          className="customs-quotas-view-terms-and-conditions__button"
          text={linkText}
          behavior={LINK_BEHAVIORS.text}
        />
      </p>
      {termsPopup && (
        <CustomsQuotasTermsPopup
          {...termsPopup}
          ref={termsPopupRef}
          isOpenedByDefault={false}
          readOnlyMode={true}
        />
      )}
    </React.Fragment>
  );
};

CustomsQuotasViewTermsAndConditions.propTypes = {
  text: PropTypes.string,
  linkText: PropTypes.string,
  termsPopup: PropTypes.exact(CustomsQuotasTermsPopup.propTypes),
};

export default CustomsQuotasViewTermsAndConditions;
